import PropTypes from 'prop-types';
import {maps as gmaps} from 'google';

export const GOOGLE_MAPS_LAT_LNG = PropTypes.instanceOf(gmaps.LatLng);



// WEBPACK FOOTER //
// ./frontend/src/js/utils/google-prop.js